import React, { PureComponent } from 'react';
import classnames from 'classnames';
import raf from 'raf';

export class ColorInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase(),
      isInputActive: false,
    };
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      raf(() => this.input.focus());
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.value !== prevState.value && !prevState.isInputActive) {
      return { value: String(nextProps.value).toUpperCase() };
    }
    return null;
  }

  handleBlur() {
    if (this.state.blurValue) {
      this.setState({
        value: this.state.blurValue,
        blurValue: null,
        isInputActive: false,
      });
    }
  }

  handleChange(e) {
    this.props.onChange(e.target.value, e);
    this.setState({
      value: e.target.value,
      blurValue: String(e.target.value).toUpperCase(),
      isInputActive: true,
    });
  }

  render() {
    return (
      <div className="input-append pos-r" onClick={this.props.onClick}>
        <input
          className={classnames('color-field', this.props.inputClassName)}
          ref={node => (this.input = node)}
          value={this.state.value}
          onChange={this.handleChange.bind(this)}
          onBlur={this.handleBlur.bind(this)}
          placeholder={this.props.placeholder}
          id={this.props.id}
          style={{ maxWidth: '5em', paddingRight: '36px' }}
          type="text"
        />
        <label
          className="add-on"
          htmlFor={this.props.id}
          style={{
            backgroundColor: this.state.value,
            width: '28px',
            height: '28px',
            margin: '1px 0 0 -29px',
            padding: '0',
            position: 'relative',
            zIndex: 10,
            border: 0,
          }}
        >
          {this.props.label}
        </label>
      </div>
    );
  }
}

export default ColorInput;
